// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FooterBlockForm-space1-srPte {
	margin-bottom: 6px !important;
}

.FooterBlockForm-space2-FYflK {
	margin-bottom: 12px !important;
}

.FooterBlockForm-space3-yZc7U {
	margin-bottom: 18px !important;
}

.FooterBlockForm-space4-ZhNRz {
	margin-bottom: 24px !important;
}

.FooterBlockForm-space5-efPXY {
	margin-bottom: 30px !important;
}

.FooterBlockForm-space6-vYRKl {
	margin-bottom: 36px !important;
}

.FooterBlockForm-space7-wIbMk {
	margin-bottom: 42px !important;
}

.FooterBlockForm-space8-vWO0M {
	margin-bottom: 48px !important;
}

.FooterBlockForm-spaceTop1-fNAd4 {
	margin-top: 6px !important;
}

.FooterBlockForm-spaceTop2-RrX69 {
	margin-top: 12px !important;
}

.FooterBlockForm-spaceTop3-H0Xva {
	margin-top: 18px !important;
}

.FooterBlockForm-spaceTop4-AuNEI {
	margin-top: 24px !important;
}

.FooterBlockForm-spaceTop5-MvDGg {
	margin-top: 30px !important;
}

.FooterBlockForm-spaceTop6-nGw_z {
	margin-top: 36px !important;
}

.FooterBlockForm-spaceTop7-c18HS {
	margin-top: 42px !important;
}

.FooterBlockForm-spaceTop8-koNgN {
	margin-top: 48px !important;
}

.FooterBlockForm-noMargin-TnVAq {
	margin: 0px !important;
}

.FooterBlockForm-padding1-CpYZs {
	padding-bottom: 6px !important;
}

.FooterBlockForm-padding2-Ql93d {
	padding-bottom: 12px !important;
}

.FooterBlockForm-padding3-g8zKK {
	padding-bottom: 18px !important;
}

.FooterBlockForm-padding4-JwkgW {
	padding-bottom: 24px !important;
}

.FooterBlockForm-padding5-EnkZD {
	padding-bottom: 30px !important;
}

.FooterBlockForm-padding6-XL2wT {
	padding-bottom: 36px !important;
}

.FooterBlockForm-padding7-EXJpw {
	padding-bottom: 42px !important;
}

.FooterBlockForm-paddingTop1-q1OK8 {
	padding-top: 6px !important;
}

.FooterBlockForm-paddingTop2-Lqai0 {
	padding-top: 12px !important;
}

.FooterBlockForm-paddingTop3-jJqEE {
	padding-top: 18px !important;
}

.FooterBlockForm-paddingTop4-xKh_G {
	padding-top: 24px !important;
}

.FooterBlockForm-paddingTop5-LqMv3 {
	padding-top: 30px !important;
}

.FooterBlockForm-paddingTop6-ZfDxC {
	padding-top: 36px !important;
}

.FooterBlockForm-paddingTop7-cB56W {
	padding-top: 42px !important;
}

.FooterBlockForm-noPadding-HHdtk {
	padding: 0px !important;
}

.FooterBlockForm-spaceMarginBottom0-te0U7 {
	margin-bottom: 0;
}

.FooterBlockForm-textBold-mMnt8 {
	font-weight: 500 !important;
}

.FooterBlockForm-textBolder-FDxPJ {
	font-weight: 700 !important;
}

.FooterBlockForm-textNormal-lZpGY {
	font-weight: normal !important;
}

/*New Design Text Colors */

.FooterBlockForm-textDarkBlue-NJTiD {
	color: rgb(20, 39, 94) !important;
}

.FooterBlockForm-textLightBlue-FKrCk {
	color: rgb(57, 87, 106) !important;
}

.FooterBlockForm-textLightSandleGreen-I5PRC {
	color: rgb(76, 86, 41) !important;
}

.FooterBlockForm-textLightBrown-Tjsu4 {
	color: rgb(115, 79, 33) !important;
}

.FooterBlockForm-textMediumMaroon-uM986 {
	color: rgb(87, 37, 51) !important;
}

.FooterBlockForm-textBrown-w0Ugt {
	color: rgb(160, 47, 24) !important;
}

.FooterBlockForm-textMaroon-JHl2X {
	color: rgb(155, 49, 67) !important;
}

.FooterBlockForm-textDarkBrown-TgGQ2 {
	color: rgb(83, 18, 16) !important;
}

.FooterBlockForm-textMediumBrown-NGa54 {
	color: rgb(142, 28, 10) !important;
}

.FooterBlockForm-textSkyBlue-fGXAE {
	color: rgb(37, 117, 141) !important;
}

.FooterBlockForm-textGray-Ni4b9 {
	color: rgb(77, 65, 51) !important;
}

.FooterBlockForm-errorMessage-ghMS1 {
  margin-top: 5px;
  margin-bottom: 5px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
  /* margin-left: 5px; */
}

/** Admin - Common - Start **/

.FooterBlockForm-userText-lg16H {
	padding-top: 3px;
	color: var(--common-text-color);
	margin: 0px;
	font-size: 14px;
}

.FooterBlockForm-panelHeader-kWeoH {
	border-radius: 4px;
	padding: 20px 25px;
	border: 1px solid var(--primary-border);
}

.FooterBlockForm-exportSection-dJGB9 {
	background: var(--common-gray-bg-color);
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
	border-top-left-radius: 20px;
	border-top-right-radius: 20px;
}

.FooterBlockForm-exportSectionGridSub-HY0c1 {
	grid-template-columns: 50% 49% !important;
}

.FooterBlockForm-exportText-MT5qZ {
	color: var(--common-text-color) !important;
	text-decoration: none !important;
	display: inline-block;
	float: right;
}

.FooterBlockForm-exportLinkImg-t41jc {
	background: var(--primary-white-bg);
	padding: 10px;
	margin-left: 12px;
	border-radius: 4px;
}

.FooterBlockForm-exportImg-XZNau {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.FooterBlockForm-linkBtn-pIhun {
	line-height: 24px;
	display: inline-block;
	vertical-align: middle;
	margin-right: 15px;
	text-align: center;
}

.FooterBlockForm-table-qvvbQ {
	display: table;
}

.FooterBlockForm-tableRow-ZZkm2 {
	display: table-row;
}

.FooterBlockForm-tableCell-DBouN {
	display: table-cell;
	float: none;
}

.FooterBlockForm-formGroup-vDawT {
	margin-bottom: 6px;
}

.FooterBlockForm-marginTop0-oWEwS {
	margin-top: 0;
}

.FooterBlockForm-marginBottom20-ycQpP {
	margin-bottom: 20px;
}

/******************* Admin Banner Image Section Start ****************/

.FooterBlockForm-bannerImageBg-QI6lJ {
	width: 100%;
	height: 100%;
	min-height: 179px;
	background-size: contain;
	background-repeat: no-repeat;
	background-position: 50% 50%;
	position: relative;
	border-radius: 0px;
}

.FooterBlockForm-bannerDelete-QKyAB {
	position: absolute;
	top: 5px;
	right: 20px;
}

/*******************Admin Modal Start **********************/

a,
a:hover {
	cursor: pointer;
}

.FooterBlockForm-exportLink-LoXWc {
	padding-top: 10px;
	padding-right: 10px;
}

.FooterBlockForm-seachContent-VB84p {
	padding-left: 0px;
	margin-bottom: 5px;
}

.FooterBlockForm-marginBottom9-hAZNQ {
	margin-bottom: 9px;
}

.FooterBlockForm-spaceTop52-EW9xl {
	margin-top: 52px;
}

.FooterBlockForm-profileViewInner-vXxLv {
	padding: 10px;
	border-top: 1px solid var(--primary-border);
	word-break: break-all;
}

.FooterBlockForm-profileViewMain-_ghg2 {
	border: 1px solid var(--primary-border);
	border-radius: 0px;
	border-top: 0;
}

.FooterBlockForm-profileViewlabel-fX_fm {
	display: inline-block;
	width: 38%;
	vertical-align: middle;
}

.FooterBlockForm-profileViewMainContent-aXn4q {
	display: inline-block;
	width: 62%;
	vertical-align: middle;
}

.FooterBlockForm-reviewsFormStar-llVwx {
	font-size: 32px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 2px;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
}

.FooterBlockForm-reviewsFormStar-llVwx svg {
	cursor: pointer;
}

.FooterBlockForm-addLanguageText-Ne6fd {
	font-size: 16px;
}

/***************** Export Section Start *********************/

@media screen and (max-width: 991px) {
	.FooterBlockForm-exportSection-dJGB9 {
		grid-template-columns: 100%;
	}

	.FooterBlockForm-spaceTop52-EW9xl {
		margin-top: 18px;
	}

	.FooterBlockForm-exportText-MT5qZ {
		float: none;
		margin-top: 12px;
	}

	.FooterBlockForm-exportSectionGridSub-HY0c1 {
		grid-template-columns: 100% !important;
	}
}

/***************** Export Section End *********************/

/*******************Admin Modal Start **********************/

/*******************Admin Modal End **********************/

/*********************** Profile View Section  Start***********************/

@media screen and (max-width: 767px) {
	.FooterBlockForm-profileViewlabel-fX_fm {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.FooterBlockForm-profileViewMainContent-aXn4q {
		width: 100%;
		text-align: center;
	}

	.FooterBlockForm-panelHeader-kWeoH {
		padding: 15px 15px;
	}

}

/*********************** Profile View Section  Start***********************/`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/utils.css","webpack://./src/components/siteadmin/admin-common.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC5LA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;ACLA,6BAA6B;;AAC7B;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,uCAAuC;AACxC;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,uCAAuC;CACvC,gBAAgB;CAChB,4BAA4B;CAC5B,6BAA6B;AAC9B;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,0CAA0C;CAC1C,gCAAgC;CAChC,qBAAqB;CACrB,YAAY;AACb;;AAEA;CACC,mCAAmC;CACnC,aAAa;CACb,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,iBAAiB;CACjB,qBAAqB;CACrB,sBAAsB;CACtB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,mBAAmB;AACpB;;AAGA,sEAAsE;;AACtE;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,wBAAwB;CACxB,4BAA4B;CAC5B,4BAA4B;CAC5B,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,WAAW;AACZ;;AAEA,4DAA4D;;AAC5D;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,2CAA2C;CAC3C,qBAAqB;AACtB;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,QAAQ;CACR,mBAAe;KAAf,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA,6DAA6D;;AAC7D;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,gBAAgB;CACjB;;CAEA;EACC,sCAAsC;CACvC;AACD;;AAEA,2DAA2D;;AAC3D,4DAA4D;;AAE5D,0DAA0D;;AAE1D,2EAA2E;;AAG3E;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;;CAEA;EACC,kBAAkB;CACnB;;AAED;;AAEA,2EAA2E","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.space8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.spaceMarginBottom0 {\n\tmargin-bottom: 0;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}",".errorMessage {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n  /* margin-left: 5px; */\n}","@import '../helpers.css';\n@import '../utils.css';\n\n/** Admin - Common - Start **/\n.userText {\n\tpadding-top: 3px;\n\tcolor: var(--common-text-color);\n\tmargin: 0px;\n\tfont-size: 14px;\n}\n\n.panelHeader {\n\tborder-radius: 4px;\n\tpadding: 20px 25px;\n\tborder: 1px solid var(--primary-border);\n}\n\n.exportSection {\n\tbackground: var(--common-gray-bg-color);\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n\tborder-top-left-radius: 20px;\n\tborder-top-right-radius: 20px;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--common-text-color) !important;\n\ttext-decoration: none !important;\n\tdisplay: inline-block;\n\tfloat: right;\n}\n\n.exportLinkImg {\n\tbackground: var(--primary-white-bg);\n\tpadding: 10px;\n\tmargin-left: 12px;\n\tborder-radius: 4px;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.linkBtn {\n\tline-height: 24px;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tmargin-right: 15px;\n\ttext-align: center;\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.marginTop0 {\n\tmargin-top: 0;\n}\n\n.marginBottom20 {\n\tmargin-bottom: 20px;\n}\n\n\n/******************* Admin Banner Image Section Start ****************/\n.bannerImageBg {\n\twidth: 100%;\n\theight: 100%;\n\tmin-height: 179px;\n\tbackground-size: contain;\n\tbackground-repeat: no-repeat;\n\tbackground-position: 50% 50%;\n\tposition: relative;\n\tborder-radius: 0px;\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: 5px;\n\tright: 20px;\n}\n\n/*******************Admin Modal Start **********************/\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.seachContent {\n\tpadding-left: 0px;\n\tmargin-bottom: 5px;\n}\n\n.marginBottom9 {\n\tmargin-bottom: 9px;\n}\n\n.spaceTop52 {\n\tmargin-top: 52px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-top: 1px solid var(--primary-border);\n\tword-break: break-all;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 0px;\n\tborder-top: 0;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%;\n\tvertical-align: middle;\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n\tvertical-align: middle;\n}\n\n.reviewsFormStar {\n\tfont-size: 32px;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 2px;\n\tflex-wrap: wrap;\n}\n\n.reviewsFormStar svg {\n\tcursor: pointer;\n}\n\n.addLanguageText {\n\tfont-size: 16px;\n}\n\n/***************** Export Section Start *********************/\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.spaceTop52 {\n\t\tmargin-top: 18px;\n\t}\n\n\t.exportText {\n\t\tfloat: none;\n\t\tmargin-top: 12px;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n}\n\n/***************** Export Section End *********************/\n/*******************Admin Modal Start **********************/\n\n/*******************Admin Modal End **********************/\n\n/*********************** Profile View Section  Start***********************/\n\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 15px 15px;\n\t}\n\n}\n\n/*********************** Profile View Section  Start***********************/"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `FooterBlockForm-space1-srPte`,
	"space2": `FooterBlockForm-space2-FYflK`,
	"space3": `FooterBlockForm-space3-yZc7U`,
	"space4": `FooterBlockForm-space4-ZhNRz`,
	"space5": `FooterBlockForm-space5-efPXY`,
	"space6": `FooterBlockForm-space6-vYRKl`,
	"space7": `FooterBlockForm-space7-wIbMk`,
	"space8": `FooterBlockForm-space8-vWO0M`,
	"spaceTop1": `FooterBlockForm-spaceTop1-fNAd4`,
	"spaceTop2": `FooterBlockForm-spaceTop2-RrX69`,
	"spaceTop3": `FooterBlockForm-spaceTop3-H0Xva`,
	"spaceTop4": `FooterBlockForm-spaceTop4-AuNEI`,
	"spaceTop5": `FooterBlockForm-spaceTop5-MvDGg`,
	"spaceTop6": `FooterBlockForm-spaceTop6-nGw_z`,
	"spaceTop7": `FooterBlockForm-spaceTop7-c18HS`,
	"spaceTop8": `FooterBlockForm-spaceTop8-koNgN`,
	"noMargin": `FooterBlockForm-noMargin-TnVAq`,
	"padding1": `FooterBlockForm-padding1-CpYZs`,
	"padding2": `FooterBlockForm-padding2-Ql93d`,
	"padding3": `FooterBlockForm-padding3-g8zKK`,
	"padding4": `FooterBlockForm-padding4-JwkgW`,
	"padding5": `FooterBlockForm-padding5-EnkZD`,
	"padding6": `FooterBlockForm-padding6-XL2wT`,
	"padding7": `FooterBlockForm-padding7-EXJpw`,
	"paddingTop1": `FooterBlockForm-paddingTop1-q1OK8`,
	"paddingTop2": `FooterBlockForm-paddingTop2-Lqai0`,
	"paddingTop3": `FooterBlockForm-paddingTop3-jJqEE`,
	"paddingTop4": `FooterBlockForm-paddingTop4-xKh_G`,
	"paddingTop5": `FooterBlockForm-paddingTop5-LqMv3`,
	"paddingTop6": `FooterBlockForm-paddingTop6-ZfDxC`,
	"paddingTop7": `FooterBlockForm-paddingTop7-cB56W`,
	"noPadding": `FooterBlockForm-noPadding-HHdtk`,
	"spaceMarginBottom0": `FooterBlockForm-spaceMarginBottom0-te0U7`,
	"textBold": `FooterBlockForm-textBold-mMnt8`,
	"textBolder": `FooterBlockForm-textBolder-FDxPJ`,
	"textNormal": `FooterBlockForm-textNormal-lZpGY`,
	"textDarkBlue": `FooterBlockForm-textDarkBlue-NJTiD`,
	"textLightBlue": `FooterBlockForm-textLightBlue-FKrCk`,
	"textLightSandleGreen": `FooterBlockForm-textLightSandleGreen-I5PRC`,
	"textLightBrown": `FooterBlockForm-textLightBrown-Tjsu4`,
	"textMediumMaroon": `FooterBlockForm-textMediumMaroon-uM986`,
	"textBrown": `FooterBlockForm-textBrown-w0Ugt`,
	"textMaroon": `FooterBlockForm-textMaroon-JHl2X`,
	"textDarkBrown": `FooterBlockForm-textDarkBrown-TgGQ2`,
	"textMediumBrown": `FooterBlockForm-textMediumBrown-NGa54`,
	"textSkyBlue": `FooterBlockForm-textSkyBlue-fGXAE`,
	"textGray": `FooterBlockForm-textGray-Ni4b9`,
	"errorMessage": `FooterBlockForm-errorMessage-ghMS1`,
	"userText": `FooterBlockForm-userText-lg16H`,
	"panelHeader": `FooterBlockForm-panelHeader-kWeoH`,
	"exportSection": `FooterBlockForm-exportSection-dJGB9`,
	"exportSectionGridSub": `FooterBlockForm-exportSectionGridSub-HY0c1`,
	"exportText": `FooterBlockForm-exportText-MT5qZ`,
	"exportLinkImg": `FooterBlockForm-exportLinkImg-t41jc`,
	"exportImg": `FooterBlockForm-exportImg-XZNau`,
	"linkBtn": `FooterBlockForm-linkBtn-pIhun`,
	"table": `FooterBlockForm-table-qvvbQ`,
	"tableRow": `FooterBlockForm-tableRow-ZZkm2`,
	"tableCell": `FooterBlockForm-tableCell-DBouN`,
	"formGroup": `FooterBlockForm-formGroup-vDawT`,
	"marginTop0": `FooterBlockForm-marginTop0-oWEwS`,
	"marginBottom20": `FooterBlockForm-marginBottom20-ycQpP`,
	"bannerImageBg": `FooterBlockForm-bannerImageBg-QI6lJ`,
	"bannerDelete": `FooterBlockForm-bannerDelete-QKyAB`,
	"exportLink": `FooterBlockForm-exportLink-LoXWc`,
	"seachContent": `FooterBlockForm-seachContent-VB84p`,
	"marginBottom9": `FooterBlockForm-marginBottom9-hAZNQ`,
	"spaceTop52": `FooterBlockForm-spaceTop52-EW9xl`,
	"profileViewInner": `FooterBlockForm-profileViewInner-vXxLv`,
	"profileViewMain": `FooterBlockForm-profileViewMain-_ghg2`,
	"profileViewlabel": `FooterBlockForm-profileViewlabel-fX_fm`,
	"profileViewMainContent": `FooterBlockForm-profileViewMainContent-aXn4q`,
	"reviewsFormStar": `FooterBlockForm-reviewsFormStar-llVwx`,
	"addLanguageText": `FooterBlockForm-addLanguageText-Ne6fd`
};
module.exports = ___CSS_LOADER_EXPORT___;
